import { User } from '../../../models/user';
import { createAction, props } from '@ngrx/store';


export const login = createAction('[User] Log in', props<{ payload: User }>());
export const updateUser = createAction('[User] Update User', props<{ payload: Partial<User> }>());
export const logout = createAction('[User] Log out');
